<template>
  <div id="organisation-attendees">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="filter-card card card-collapsed">
            <div class="card-header header-elements-inline">
              <h5 class="card-title">{{ $t("event.buttons.filter") }}</h5>

              <div class="header-elements">
                <div class="list-icons">
                  <el-button-group>
                    <el-button size="mini" @click="resetFilter" round>{{ $t('event.buttons.reset') }}</el-button>
                    <el-button size="mini" type="danger" @click="isFilterEnabled = false" round>{{ $t('event.buttons.close') }}</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                     <el-select v-model="requestForm.eventIds" v-if="teamContent" multiple>
                <el-option v-for="item in teamContent.events" :key="item.id" :label="item.title" :value="item.id" class="custom-option-event">
                  <el-avatar :size="'small'" :src="item.image != null ? $imageus + item.image + '?width=200&height=200' : ''"></el-avatar>
                  <span class="custom-option-title">{{ item.title }}</span>
                </el-option>
              </el-select>
                </div>
                    <el-button type="primary" @click="search">{{ $t("event.buttons.filter") }}</el-button>
              </div>
            </div>
          </div>
        </transition>
    
        <div class="card" >
          <div class="card-header header-elements-inline" style="padding-bottom: 0px">
            <h5 class="card-title">{{ $t("pages.organisationAttendees.attendees") }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.filter')" placement="top">
                  <el-button round icon="el-icon-edi" size="medium" class="filter-button" @click="isFilterEnabled = !isFilterEnabled">{{ $t("event.buttons.filter") }}</el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button round icon="fas fa-redo-alt" size="medium" @click="isFilterEnabled = !isFilterEnabled"></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <PageCountInfo :total="getAttendeeList.total" :skip="skip" :take="take" />

          <el-table ref="multipleTable" :data="getAttendeeList.attendees" style="width: 100%" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
          

            <el-table-column :label="$t('pages.organisationAttendees.attendee')" width="400">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.firstName }} {{scope.row.lastName}}
                </span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('pages.organisationAttendees.uniqValue')" min-width="170">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.uniqueValue }}
                </span>
              </template>
            </el-table-column>
            <template slot="empty">
              {{ $t("pages.organisationAttendees.pleaseSelectEvent") }}
            </template>
          </el-table>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="requestForm.skip" :page-sizes="[20, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="getAttendeeList.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PageCountInfo from '@/components/PageCountInfo';

import $ from 'jquery';
import { runInThisContext } from 'vm';
export default {
  components: { PageCountInfo },
  name: 'OrganisationAttendees',

  metaInfo: {
    title: 'Katılımcılar',
  },
  data() {
    return {
      isFilterEnabled: false,
      timeout: null,
      requestForm: {
        eventIds: [],
        eventIds2: [],
        reportType: 1,
        skip: 1,
        take: 20,
        page: 1,
      },
    };
  },

  methods: {
    exportExcel() {
      this.$confirm(this.$t('message.export'), this.$t('message.warn'), {
        confirmButtonText: this.$t('event.variables.yes'),
        cancelButtonText: this.$t('event.variables.no'),
        type: 'warning',
      }).then(() => {
        axios.post('speaker/export', { id: null }).then((res) => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },

    excelProgress(event) {
      this.excelPercent = event.percent;
    },

    itemUpdated(item) {
      var index = this.$store.state.speakers.items.findIndex((k) => k.id == item.id);
      if (index != -1) {
        this.$store.state.speakers.items.splice(index, 1, item);
      }
    },

    itemAdded(item) {
      this.$store.dispatch('getSpeakers');
    },

    handleSizeChange(take) {
      this.requestForm.take = take
    },

    handleCurrentChange(page) {
      $('html, body').animate({ scrollTop: 0 }, 350);
      this.requestForm.page = page
    },

    deleteItem(index) {
      this.$store.dispatch('deleteSpeaker', { index, context: this });
    },

    statusChanged(value, index) {
      this.$store.dispatch('toggleSpeaker', { index, value });
    },

    handleSelectionChange(items) {
      this.$store.commit('setSelectedSpeakers', items);
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return 'row-active';
      }
      return 'row-passive';
    },
    resetFilter(){
      this.requestForm.eventIds = null;
      this.$store.commit("setAttendeList", {attendees:[],total:0});
    },
    async search(){
        await this.$store.dispatch("getAttendeeList", this.requestForm);
    },
  },

  async mounted() {
    await this.$store.dispatch('getOrganizationTeamContent');
    // this.$store.dispatch("getSpeakers");
  },

  async created() {},

  computed: {
    skip() {
      return (this.requestForm.page - 1) * this.requestForm.take;
    },
    take() {
      return this.skip + this.getAttendeeList.attendees.length;
    },
    teamContent() {
      return this.$store.getters.getOrganizationTeamContent;
    },
    getAttendeeList(){
      return this.$store.getters.getAttendeeList;
    },
   
  },
   watch: {
      "requestForm.take": async function  (){
        await this.$store.dispatch("getAttendeeList", this.requestForm);

      },
      "requestForm.skip": async function  (){
        await this.$store.dispatch("getAttendeeList", this.requestForm);

      },
    }
};
</script>

<style lang="less">
#organisation-attendees {
  width: 100%;

  .content-wrapper {
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganisationAttendees.vue